module.exports = __webpack_public_path__ + "static/media/DroneControlCenterActive.fb9abbd6.png";